const localization = {
  nl: {
    title: 'Pagina niet gevonden'
  },
  de: {
    title: 'Site nicht gefunden'
  },
  en: {
    title: 'Page not found'
  }
}

export default localization



// WEBPACK FOOTER //
// ./src/localization/404.js